import React from 'react';
import ReactDOM from 'react-dom';
import {default as Router} from 'react-router-dom/BrowserRouter';
import Route from 'react-router-dom/Route';

import { Helmet } from 'react-helmet';
import 'react-transition-group/Transition';

import 'styles/master.sass'

import uiState from 'core/uiState'
import {StatusConstants} from 'core/uiState';


function asyncComponent(getComponent) {
    return class AsyncComponent extends React.Component {
        static Component = null;
        state = { Component: AsyncComponent.Component };

        componentWillMount() {
            if (!this.state.Component) {
                uiState.setStatus(StatusConstants.RENDERING);

                getComponent().then(Component => {
                    AsyncComponent.Component = Component;
                    this.setState({ Component });
                    uiState.setStatus(StatusConstants.READY);
                })
            }
        }
        render() {
            const { Component } = this.state;
            if (Component) {
                return <Component {...this.props} />
            }
            return null
        }
    }
}

import HomePage from 'pages/Home'
import Events from 'modules/Events'
import People from 'modules/People'

import {observable, computed, action} from 'mobx';

import {observer, Provider} from 'mobx-react';
import Status from 'elements/Status'

let link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.href = 'https://fonts.googleapis.com/css?family=Fira+Sans:200,200i,400,400i,600,600i|Graduate&subset=latin-ext';
document.head.appendChild(link);

function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/*
const applicationServerKey = urlB64ToUint8Array("BAIX_0Ri4DMlEiwQjk1_14GgJfw8h9czt_nR_0c4WNqpOQykGpQwQWV6Wi2Q254lhrvyMxiX5cOqB4-nKauSVPo");

if('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw-precache-static.js').then(registration => {
        console.log('123 SW registered: ', registration);
        registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey
        })
            .then(function(subscription) {
                console.log('User is subscribed.', subscription);

                // updateSubscriptionOnServer(subscription);

                isSubscribed = true;
            })
            .catch(function(err) {
                console.log('Failed to subscribe the user: ', err);
            });
    }).catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
    });
}
*/


const Live = asyncComponent(() => import(/* webpackChunkName: 'live' */ 'modules/Live').then(module => module.default));
const Blog = asyncComponent(() => import(/* webpackChunkName: 'blog' */ 'modules/Blog').then(module => module.default));
const Contact = asyncComponent(() => import(/* webpackChunkName: 'contact' */ 'modules/Contact').then(module => module.default));
const Partners = asyncComponent(() => import(/* webpackChunkName: 'partners' */ 'modules/Partners').then(module => module.default));
const AboutPage = asyncComponent(() => import(/* webpackChunkName: 'about' */ 'pages/About').then(module => module.default));


import fecha from 'fecha'
fecha.i18n = {
    dayNamesShort: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
    dayNames: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
    monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
    amPm: ['am', 'pm'],
    // D is the day of the month, function returns something like...  3rd or 11th
    DoFn: function (D) {
        return D + '.';
    }
};

import Layout from 'layouts/Default'

let lastKnownLocation;

// Because passing in mobx observables to react router's render func yielded no reactivity whatsoever...
const GlobalDimmer = observer(() => <Status {...uiState.loader} show={uiState.shouldShowDimmer}/>);

ReactDOM.render(
    <Provider uiState={uiState}>
        <Router>
            <Layout>
                <Helmet>
                    <link rel="alternate" type="application/rss+xml" title="Gamedev.js - Wydarzenia" href={__bootstrap.config.apiBaseUrl + 'events.rss'} />
                </Helmet>

                <Route path="/" component={GlobalDimmer}/>

                <Route exact path="/" component={HomePage} />
                <Route path="/wydarzenia" component={Events}/>
                <Route path="/kontakt" component={Contact}/>
                <Route path="/prelegenci" component={People}/>
                <Route path="/partnerzy" component={Partners}/>
                <Route path="/blog" component={Blog}/>
                <Route path="/live" component={Live}/>
                <Route path="/o-nas" component={AboutPage}/>

                <Route path="/" render={({location}) => {
                    if (typeof window.gtag === 'function' && lastKnownLocation !== location.pathname) {
                        lastKnownLocation = location.pathname;
                        gtag('config', 'UA-37334507-6', {
                            'page_path': location.pathname + location.search
                        });
                    }

                    return null
                }} />
            </Layout>
        </Router>
    </Provider>,
    document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/client.js